export const GET_LOGS_START = "GET_LOGS_START";
export const GET_LOGS_SUCCESS = "GET_LOGS_SUCCESS";
export const GET_LOGS_FAIL = "GET_LOGS_FAIL";
